const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/Plans',
    authenticatedUserEntryPath: '/Reservations',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
}

export default appConfig
